import React, { useState, useEffect } from 'react';
import { Button, Icon, Dialog, Checkbox } from '@tencent/spaui';
import _ from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import { CorpSelector } from './corpSelector';

const QwAuth = (props) => {
  const [dataList, setDataList] = useState([]);
  const [authType, setAuthType] = useState(1);
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(false);

  const getAuthList = () => {
    RPCFactory.qwBoard.authList().done((data) => {
      if (data && _.isArray(data.list)) {
        setDataList(data.list);
      }
    });
  }
  useEffect(() => {
    getAuthList();
  }, []);
  const openAuthPage = () => {
    RPCFactory.qwBoard
    .authorize(authType)
    .done((data) => {
      const redirectUrl = `${window.location.origin + window.location.pathname}#/qw/setting/auth`;
      const uri = data.url;
      console.log(encodeURIComponent(redirectUrl));
      window.open(uri, '_blank');
    })
    .fail((status, msg) => {
      alert(msg);
    });
  };
  const onAdd = () => {
    setShow(true);
  };
  const onConfirmAdd = () => {
    setShow(false);
    openAuthPage();
  };
  const handleCheckChange = (event, value) => {
    setChecked(value);
  };
  const handleOpenStatement = () => {
    window.open('https://leads.gdtimg.com/qzone/biz/gdt/leads-cdn/doc/wechat_work_batch_auth_agreement.pdf', '_blank');
  };
  const renderContent = () => (
    <div className="shouquan">
      <div className="toolbars">
        <div className="toolbar table-toolbar">
          <div className="toolbar-left">
            <Button displayType="primary" onClick={onAdd}>
              <Icon type="add" />
              新增授权
            </Button>
            <span className="btn-tips">
            一个广告主账号可同时授权多个企业微信，若需要对多个广告主账号授权同一个企业微信，请联系腾讯内部运营同学提交申请。
            </span>
          </div>
        </div>
      </div>
      <div className="imp-cards clearfix">
        {dataList.map((ele) => {
          const {
            corpId,
            corpName = '',
            corpSquareLogoUrl = '',
            corpType,
            suiteIndex,
            corpFullName,
            authorizeTime,
            authDimension,
            groupName,
          } = ele || {};
          const suiteIndexs = ele.suiteIndexs ? ele.suiteIndexs : [suiteIndex]; // 兼容老接口
          const time = new Date(authorizeTime).toLocaleDateString().split('/').join('-');
          const authorizer = groupName || window.pageProps.companyName;
          const authorizeType = corpType == 'verified' ? '已认证' : '未认证';
          return (
            <div className="imp" key={corpId}>
              <div className="applications">
                {suiteIndexs.map((suiteIndex) => {
                  return <span className="sg">{suiteIndex == 1 ? 'web应用授权' : '小程序应用授权'}</span>;
                })}
              </div>
              <div className="img">
                <img src={corpSquareLogoUrl} alt="" />
              </div>
              <div className="wd-info">
                <p className="name">{corpName}</p>
                <p className="name-tip">
                  <span className="rz rz-on">{authorizeType}</span>
                  {corpFullName}
                </p>
                <p className="time">{`授权方: ${authorizer}`}</p>
                <p className="time">{`授权时间: ${time}`}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <main className="main" id="main">
      <CorpSelector {...props} onChange={getAuthList} />
      <div className="card card-set-height">
        <div id="datarea">{renderContent()}</div>
      </div>
      <Dialog
        show={show}
        type="normal"
        className="spaui-dialog-confirm-normal add-auth-confirm"
        hideHeader={true}
        backdrop
        onSubmit={onConfirmAdd}
        onCancel={() => setShow(false)}
        onClose={() => setShow(false)}
        submitButtonProps={{ disabled: !checked }}
        style={{ width: '470px' }}
      >
        <div className='dialog-main'>
          <div className='dialog-header'>
            <div className='icon-wechat-work' />
            <span className="wechat-auth-title" style={{ marginTop: '3px' }}>
              企业微信授权
            </span>
          </div>
          <div className='dialog-content'>
            授权企业微信后，可在线索管理平台查看并管理授权范围内员工的所有客户列表， 披露企微客户广告信息，进行后链路营销管理。
          </div>
          <div className='dialog-check'>
            <Checkbox
              value='1'
              checked={!!checked}
              onChange={handleCheckChange}
            />
            <span className='read'>已阅读并同意</span>
            <span className='statement' onClick={handleOpenStatement}>《企业微信授权协议》</span>
          </div>
        </div>
      </Dialog>
    </main>
  );
};

export default QwAuth;